import { SearchComponentEnum } from "@utils/search/@types/searchComponent";
import { getDefaultComponentConfiguration } from "@utils/search/defaultConfiguration";

import { SearchConfiguration } from "@redux/modules/value/search/search.types";

const invalidateConfiguration = (
    configuration: SearchConfiguration,
    invalidations: Array<SearchComponentEnum>,
) => ({
    ...configuration,
    components: configuration.components.map(component =>
        invalidations.includes(component.component)
            ? getDefaultComponentConfiguration(component.component)
            : component,
    ),
});

export { invalidateConfiguration };
